import { IGetGroupJwtRequestParams, JwtTokenFullData } from 'multirpc-sdk';

import { MultiService } from 'modules/api/MultiService';
import { createQuerySelectors } from 'store/utils/createQuerySelectors';
import { decryptJWT } from 'modules/common/utils/decryptJWT';
import { web3Api } from 'store/queries';

export interface IFetchTeamAccountJWTParams extends IGetGroupJwtRequestParams {}

export const fetchTeamAccountJWTFallback: JwtTokenFullData = {};

// The endpoint name is listed in endpointsSerializedByParams constant
// in packages/protocol/src/store/queries/index.ts file.
// If the name has changed it should be refelected there as well.
export const {
  endpoints: { fetchTeamAccountJWT },
  useFetchTeamAccountJWTQuery,
  useLazyFetchTeamAccountJWTQuery,
} = web3Api.injectEndpoints({
  endpoints: build => ({
    fetchTeamAccountJWT: build.query<
      JwtTokenFullData,
      IFetchTeamAccountJWTParams
    >({
      queryFn: async ({ group }) => {
        const api = MultiService.getService().getAccountingGateway();

        const { jwt_data: jwt } = await api.getGroupJwtToken({ group });

        const decryptedJWT = await decryptJWT({ isEncrypted: false, jwt });

        return { data: decryptedJWT };
      },
    }),
  }),
});

export const {
  selectDataWithFallbackCachedByParams: selectTeamAccountJWT,
  selectLoadingCachedByParams: selectTeamAccountJWTLoading,
  selectStateCachedByParams: selectTeamAccountJWTState,
} = createQuerySelectors({
  endpoint: fetchTeamAccountJWT,
  fallback: fetchTeamAccountJWTFallback,
});
